import React, { Fragment, KeyboardEvent } from 'react';
import { connect, Provider } from 'react-redux';

import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';
import { TextField, WithStyles, IconButton, InputAdornment,} from '@material-ui/core';

import { AppState, Actions, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import { ThemeProvider } from '@material-ui/core/styles';
import CONFIG from '../../cfg/config';
import { ReservationId, bookService, Info, UserData, FakturaVatService } from '../../api';
import ReactDOM from 'react-dom';
import DialogEnd from './End';
import themeDialog from '../../themes-dialog';

import { outerTheme } from '../../themes';
import { sendErrorLog, phoneSplit } from '../common/helpers';
import Klawiatura from 'app/components/Klawiatura';
import DialpadIcon from '@mui/icons-material/Dialpad';
import { Content } from 'app/formularz/Order';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaidIcon from '@mui/icons-material/Paid';

import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import PinIcon from '@mui/icons-material/Pin';
import SmsIcon from '@mui/icons-material/Sms';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

//PM 2021-10-15
export class Data {
    phone: string = '';
    address: string = '';
    order: number = 0;
    sum: number = 0;
    id: number = 0;

    constructor(data?: any) {
        if (data) {
            this.phone = data.phone;
            this.address = data.address;
            this.order = data.order;
            this.sum = data.sum;
            this.id = data.id;
        }
    }
}

//PM 2021-11-25
//wstrzykniecie tylko uzywanych pol z magazynu danych
type SmsCodeProps = {
    dialogSms: number,
    contact: Info,
    data: Data,
    content?: Content[],
    userData: UserData,
}

//PM 2021-11-25
type SmsCodeState = {
    open: boolean,
    smsCode: string,
    smsResponse: number,
    openResponse: boolean
    openKlawiatura: boolean
}

class SmsCode extends React.Component<SmsCodeProps & WithStyles<typeof styles>, SmsCodeState> {
    stylInputaRezerwacja: React.CSSProperties = { padding: "8px 14px", textAlign: "left", fontWeight: "bold", fontSize: "1rem" };

    //PM 2021-10-15
    //this.state =
    constructor(props: SmsCodeProps & WithStyles<typeof styles>) {
        super(props, {});

        this.state = {
            open: true,
            smsCode: "",
            smsResponse: 0,
            openResponse: false,
            openKlawiatura: false
        };

        if(this.props.data){
            this.setCheckInterval()
        }
    }

    interval: any;
    timeout: any;

    //PM 2021-11-25
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    componentDidUpdate(prevProps: SmsCodeProps) {
        if (this.props.dialogSms !== prevProps.dialogSms) {
            this.setState({ open: true, smsCode: "" })
            this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "white" };
        }

    }

    setOpenKlawiatura = () => {
        this.setState({openKlawiatura: true})
      }
  
      setCloselawiatura = () => {
        this.setState({openKlawiatura: false})
      }

    setCheckInterval = () => {
        this.interval = setInterval(() => {
            this.checkState();
          }, 10000); // 10s
          this.timeout = setTimeout(() => {
            clearInterval(this.interval);
          }, 600000); //10 min
    }

    checkState = async () => {
        try {
            let res = await FakturaVatService.getHeader({
                hotelId: CONFIG.hotelID,
                dokNr: this.props.data.order.toString()
            }, {})

            if(res && res.result && res.result[0] && res.result[0].zamkniety.toUpperCase() === "T"){

                clearInterval(this.interval);
                clearTimeout(this.timeout);
                this.close()
                await store.dispatch(Actions.pageState.updateBasket([]));
                ReactDOM.render(
                    <Provider store={store}>
                        <MuiThemeProvider theme={themeDialog}>
                            <DialogEnd success={true} data={this.props.data} paymentId={""} pay_web={this.props.contact.payWeb} content={this.props.content}/>
                        </MuiThemeProvider>
                    </Provider>
                    , document.getElementById("dialog"));
                await store.dispatch(Actions.pageState.openDialogEnd());
            }

        } catch (error) {
            console.log(error)
        }
    }


    //PM 2021-09-01
    //console.error -> console.log()
    async sendSuccess(dokNr: number) {
        try {
            const res: ReservationId = await bookService.reservConfirm3(
                {
                    hotelId: CONFIG.hotelID,
                    aOperatorId: Number(sessionStorage.getItem("operator_id")),
                    aDokNr: dokNr,
                    aPayWeb: Number(this.props.contact.payWeb) // 2
                }, {})
            return res.result[0]
            //console.log(res)  
        } catch (error) {
            console.log(error)
            await sendErrorLog( "0", "-1", '/manager/fakturaKoszykPotwierdz2')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/fakturaKoszykPotwierdz2", 2))
            return 0
        }
    }

    // async sendFailure() {
    //     try {
    //         let res: ReservationId = await bookService.reservCancel(
    //             {
    //                 hotelId: CONFIG.hotelID,
    //                 aOperatorId: Number(sessionStorage.getItem("operator_id")),
    //                 aDokNr: Number(this.props.data.order) || 0
    //             }, {})
    //         //console.log(res)    
    //     } catch (error) {
    //         console.error
    //     }
    // }

    close = () => {
        this.setState({ open: false, smsCode: "", smsResponse: 0, openResponse: false })
    };

    //PM 2021-11-25
    //poprawka typow
    getSmsCode = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        this.setState({ smsCode: String(event.target.value) })
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
    }

    setNumber = (field: string, value: any, shouldValidate?: boolean | undefined) => {
        this.setState({ smsCode: String(value) })
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
    }

    

    confirmSmsCode = async () => {
        if (this.props.data) {
            await this.smsReservation()
        } else {
            await this.smsPayment()
        }

    }

    //PM 2021-11-25
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    //poprawka typow
    smsReservation = async () => {
        // mz 2022-03-29 sprawdzanie 4 ostatnich cyfr zamiast całego kodu sms (dla krótkich kodów)
        let orderNr = String(this.props.data.order);
        //console.log('OrderNr: ' + orderNr + "(" + orderNr.slice(orderNr.length - 4) + ") vs " + this.state.smsCode.split(" ").join(""));
        let newCondition = orderNr.slice(orderNr.length - 4) === this.state.smsCode.split(" ").join("");
        let oldCondition = orderNr  === this.state.smsCode.split(" ").join("");

        if (newCondition || oldCondition) {
            let res = await this.sendSuccess(Number(this.props.data.order) || 0)
            this.close()
            await store.dispatch(Actions.pageState.updateBasket([]));

            if(res > 0){ //sukces
                ReactDOM.render(
                    <Provider store={store}>
                        <MuiThemeProvider theme={themeDialog}>
                            <DialogEnd success={true} data={this.props.data} paymentId={""} pay_web={this.props.contact.payWeb} content={this.props.content}/>
                        </MuiThemeProvider>
                    </Provider>
                    , document.getElementById("dialog"));
            } else { //porażka
                ReactDOM.render(
                    <Provider store={store}>
                        <MuiThemeProvider theme={themeDialog}>
                            <DialogEnd success={false} data={this.props.data} paymentId={""} pay_web={this.props.contact.payWeb} content={this.props.content}/>
                        </MuiThemeProvider>
                    </Provider>
                    , document.getElementById("dialog"));
            }
            clearInterval(this.interval);
            clearTimeout(this.timeout);
            await store.dispatch(Actions.pageState.openDialogEnd());


        } else {
            //this.sendFailure()
            //this.setState({ open: false })
            ReactDOM.render(

                <Provider store={store}>
                    <MuiThemeProvider theme={themeDialog}>
                        <DialogEnd success={false} data={this.props.data} paymentId={""} pay_web={this.props.contact.payWeb} content={this.props.content}/>
                    </MuiThemeProvider>
                </Provider>
                , document.getElementById("dialog"));
            await store.dispatch(Actions.pageState.openDialogEnd());
        }
    }

    smsPayment = async () => {
        let response = await this.sendSuccess(Number(this.state.smsCode) || 0)
        this.setState({ smsResponse: response || 0, openResponse: true, open: false })
    }

    onKeyDown = (event: KeyboardEvent<HTMLImageElement>) => {
        console.log(event)
        if(event.key === 'Enter') {
            this.confirmSmsCode()       
        }
    }

    Icon = (Icon: any, color: string = '#458B00') => {
        return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
    }


    //PM 2021-11-25
    //onClick={this.confirmSmsCode}
    render() {
        const { classes } = this.props;
        let err = this.state.smsCode !== "" && !this.state.smsCode.replace(/\s/g, "").match(/(^\d{1,}$)/)
        let disabled = this.state.smsCode === "" || !this.state.smsCode.replace(/\s/g, "").match(/(^\d{1,}$)/)

        return (
            <Fragment>
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    fullWidth
                    open={this.state.open}
                >
                    <DialogTitle disableTypography style={{ minWidth: "280px" }}>
                        <Typography variant="h5" component="h2" style={{ fontSize: "1.25rem"}} color="primary" className={classes.padding}>
                            <b>{"SMS KOD"}</b>
                        </Typography>
                        <hr />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`} style={{ paddingLeft: "0" }} >
                            {"Info"}
                        </DialogContentText>
                        {this.props.data ?
                            <Fragment>
                                <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`}>
                                    {this.Icon(PaidIcon)}{'kwota zamówienia:'} <b className={classes.primary}>{this.props.data.sum.toFixed(2) + " zł"}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`}>
                                {this.Icon(LocationOnIcon)}{'adres:'} <b className={classes.primary}>{this.props.data.address}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`} style={{ }}>
                                {this.Icon(PhoneIcon)}{'telefon:'} <b className={classes.primary}>{phoneSplit(this.props.data.phone)}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.padding} style={{ marginBottom: '42px' }}>
                                {this.Icon(AccountBalanceWalletIcon)}{'zamówienie jest '}<b className={classes.primary}>{(this.props.userData.dostawaJakiDzien === "") ? 'płatne przy odbiorze' : 'płatne wg regulaminu'}</b>
                                </DialogContentText>
                            </Fragment>
                            : null}
                        <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`}>
                            {this.Icon(SmsIcon)}{'za chwilę otrzymasz '}<b className={classes.primary}>SMS</b>
                        </DialogContentText>
                        {/* <DialogContentText variant="h5" component="h2" className={`${classes.padding} ${classes.gutterBottom}`}>
                            {'  * albo kliknij w '}<b className={classes.primary}>link do potwierdzenia</b>
                        </DialogContentText> */}
                        {/* <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
                            {'    ' + "aby potwierdzić zamówienie"}
                        </Typography> */}
                        {/* <DialogContentText variant="h5" component="h2" className={classes.padding} style={{ marginBottom: '30px' }}>
                            {'  * zamówienie jest '}<b className={classes.primary}>{(this.props.userData.dostawaJakiDzien === "") ? 'płatne przy odbiorze' : 'płatne wg regulaminu'}</b>
                        </DialogContentText> */}
                        <DialogContentText variant="h5" component="h2" className={classes.padding} style={{ marginBottom: '30px' }}>
                            {this.Icon(SmsIcon)}{'przepisz otrzymany '}<b className={classes.primary}>{"SMS KOD"}</b>
                        </DialogContentText>
                        <DialogContentText gutterBottom variant="h5" component="span" className={`${classes.primary} ${classes.padding} ${classes.gutterBottom}`}>
                            <Typography gutterBottom variant="h5" component="span" className={`${classes.primary} ${classes.gutterBottom}`} style={{fontWeight: 'bold'}}>
                                {"   SMS KOD: "}
                            </Typography>
                        </DialogContentText>
                        <TextField
                            type="number"
                            onKeyDown={this.onKeyDown}
                            autoFocus
                            placeholder="* * * *" //* *
                            style={{ width: window.innerWidth < 600 ? "65%" : "70%", float: "right", marginTop: "-3px" }}
                            inputProps={{ style: this.stylInputaRezerwacja }}
                            InputProps={{ classes: { input: `${classes.primaryTextField}` }, 
                                endAdornment:(
                                    <InputAdornment position="start" style={{ padding: "0" }}  >
                        
                                      <IconButton
                                        aria-label="more"
                                        aria-controls="long-menu"
                                        aria-haspopup="true"
                                        onClick={this.setOpenKlawiatura}
                                        style={{ padding: "8px", marginRight: "-18px" }}
                                      >
                                          <DialpadIcon style={{ fontSize: "1rem" }} />
                                      </IconButton>
                                      <Klawiatura open={this.state.openKlawiatura} number={this.state.smsCode} setNumber={this.setNumber} fieldName={""} close={this.setCloselawiatura} title={"wpisz sms kod"} placeholder="* * * *" max={4} oknoSms/>
                                    </InputAdornment>
                                  )
                            }}
                            value={this.state.smsCode}
                            onChange={this.getSmsCode}
                            variant="outlined"
                            error={err}
                            helperText={err ? "Niepoprawny kod" : ""}
                            
                        />
                    </DialogContent>
                    <DialogActions >
                        <Button variant="outlined" color="primary" size="small"
                            style={{ textTransform: "none", fontSize: "0.8rem" }}
                            onClick={() => this.close()}
                        >
                            <b>anuluj</b>
                        </Button>
                        <Button variant="contained" color="primary" size="small"
                            style={{ textTransform: "none", fontSize: "0.8rem" }}
                            disabled={disabled}
                            onClick={this.confirmSmsCode}
                        >
                            <b>OK</b>
                        </Button>
                    </DialogActions>

                </Dialog>
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="xs"
                    fullWidth
                    open={this.state.openResponse}
                >
                    {this.state.smsResponse > 0 ?
                        <Fragment>
                            <DialogTitle disableTypography>
                                <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem" }}>
                                    <b>sukces</b>
                                </Typography>
                                <hr />
                            </DialogTitle>
                            <DialogContent >
                                <DialogContentText>
                                    <Typography gutterBottom variant="h5" component="h2" >
                                        Zamówienie zostało przyjęte
                                    </Typography>
                                </DialogContentText>
                            </DialogContent >
                            <DialogActions >
                                <Button onClick={() => this.close()} variant="outlined" size="small" color="primary"
                                    style={{ textTransform: "none", fontSize: "0.8rem" }}
                                >
                                    <b><Trans>OK</Trans></b>
                                </Button>
                            </DialogActions>
                        </Fragment>
                        :
                        <Fragment>
                            <DialogTitle disableTypography>
                                <Typography gutterBottom variant="h5" component="h2" color="error" style={{ fontSize: "1.25rem" }}>
                                    <b>niepowodzenie</b>
                                </Typography>
                                <hr />
                            </DialogTitle>
                            <DialogContent >
                                <DialogContentText>
                                    <Typography gutterBottom variant="h5" component="h2" >
                                        Zamówienie nie zostało przyjęte
                                    </Typography>
                                    <Typography gutterBottom variant="h5" component="h2" className={classes.padding}>
                                        {'  *'} <b className={classes.secondary}>{"spróbuj ponownie"}</b>
                                    </Typography>
                                    <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
                                        {'  * '}<b className={classes.secondary}>{"lub skontaktuj się z lokalem telefonicznie"}</b>
                                    </Typography>

                                </DialogContentText>
                            </DialogContent >
                            <DialogActions >
                                <ThemeProvider theme={outerTheme}>
                                    <Button onClick={() => this.close()} variant="outlined" size="small" color="secondary"
                                        style={{ textTransform: "none", fontSize: "0.8rem" }}
                                    >
                                        <b><Trans>OK</Trans></b>
                                    </Button>
                                </ThemeProvider>
                            </DialogActions>
                        </Fragment>}
                </Dialog>
            </Fragment>
        )

    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    primaryBold: {
        color: theme.palette.primary.main,
        fontStyle: 'bold',
    },
    padding: {
        //whiteSpace: "pre" as "pre",
        paddingLeft: "7px",

        "@media (max-width: 600px)": {
            fontSize: "0.95rem",
        },
    },
    primaryTextField: {
        color: theme.palette.primary.main,
        backgroundColor: "inherit",
        textAlign: 'left' as 'left',
    },
    gutterBottom: {
        marginBottom: '0.5em',
    },
});

const mapStateToProps = (state: AppState) => ({
    dialogSms: state.pageState.dialogSms,
    contact: state.pageState.contact,
    userData: state.pageState.userData
});

export default connect(mapStateToProps)(withStyles(styles)(SmsCode));